import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { ColdSubject } from 'app/core/guards/cold-subject';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { OrderFilterValuesLoadGuard } from 'app/core/guards/order-filter-values-load.guard';
import { logger } from 'app/core/util/logger';
import { Observable } from 'rxjs';
import * as fromRoot from '..';
import { OrdersClearFilterAction } from './orders.actions';
import { goAction } from '../router/router.actions';

/**
 * Guard to synchronously clear orders filter & result
 */
@Injectable({ providedIn: 'root' })
export class ClearOrdersFilterGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    logger.debug('in ClearOrdersFilterGuard');
    return new ColdSubject(() => {
      logger.debug('Inner ClearOrdersFilterGuard');
      this.store.dispatch(new OrdersClearFilterAction());
      this.store.dispatch(goAction({ path: 'orders' }));
      return true;
    });
  }

  getDependencies(): any {
    return [OrderFilterValuesLoadGuard];
  }

  getDependencyRouteData(): any {}
}
